import React from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

const Pagnation = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="custom-pagination">
      <div className="pagination-text">
        Page {currentPage} of {totalPages}
      </div>
      <div className="pagination-arrows">
        <button
          className="pagination-btn"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <MdKeyboardArrowLeft />
        </button>
        <button
          className="pagination-btn"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <MdKeyboardArrowRight />
        </button>
      </div>
    </div>
  );
};

export default Pagnation;